import { render, staticRenderFns } from "./EdsTag.vue?vue&type=template&id=eba6b04a&"
import script from "./EdsTag.vue?vue&type=script&lang=js&"
export * from "./EdsTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports